<template>
    <div>
        <v-layout wrap>
            <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
                <v-select 
                    label="Chọn kho"
                    v-validate="'required'"
                    :items="lstWarehouse"
                    item-text="categoryName"
                    item-value="categoryId"
                    @change="onChangeWh"
                    clearable
                />
            </v-flex>
        </v-layout>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="id"
            search-url="/fixedAssets/search?sortField=createDate&"
            create-url="/fixedAssets/save"
            delete-url="/fixedAssets/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreate"
            custom-edit-item
            @editItem="openCreate"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            :acceptDelete="false"
            :hiddenFields="hiddenFields"
            orderBy="desc"
        >
        </c-search-form>
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import { cateContants } from "@/constants";
import axios from "axios";
import { mapGetters } from "vuex";
import { message } from "../../../shared/message";

export default {
    name: "fixed-assets-list",
    components: { CSearchForm },
    data: () => {
        return {
            formName: "Quản lý mã",
            formCreateName: "Thêm mới",
            department: null,
            visibleCreateDialog: false,
            timeReload: 0,
            lstWarehouse: [],
            hiddenFields: {
                warehouseId: null,
            },
            warehouseId: null,
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "code",
                    text: "Mã quản lý",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: cateContants.fixedAssetsStatus,
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "locationId",
                    text: "Địa điểm hiện tại",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "locationId",
                    items: [],
                    itemText: "categoryName",
                    itemValue: "categoryId",
                },
                {
                    value: "departmentId",
                    text: "Bộ phận hiện tại",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "departmentId",
                    items: [],
                    itemText: "deptName",
                    itemValue: "deptId",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    width: "10%",
                    sortable: false,
                    compound: true,
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        console.log(this.warehouseId);
        this.hiddenFields.warehouseId = this.warehouseId > 0 ? this.warehouseId : null;
        this.warehouseId = this.$store.state.fixedAssets.warehouseId;
        this.getWarehouse();
        this.getLocation();
        this.getDepartment();
    },

    // computed: {
    //     ...mapGetters({
    //         warehouseId: 'fixedAssets/warehouseId',
    //     }),
    // },

    methods: {
        openCreate: function (item = null) {
            if (item == null) {
                // if (this.$store.state.fixedAssets.warehouseId > 0) {
                    this.$router.push({path: '/fixedAssets/create', query: {warehouseId: this.$store.state.fixedAssets.warehouseId}});
                // } else {
                //     message.error('Bạn chưa chọn kho');
                // }
            } else {
                this.$router.push({ path: '/fixedAssets/view', query: {fixedAssetsId: item.id} });
            }
        },
        closeCreateDialog: function () {
            this.department = null;
            this.visibleCreateDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },
        getWarehouse() {
            axios.post(
                process.env.VUE_APP_API_URL +
                "/category/listByType?type=WAREHOUSE&description=1"
            )
                .then((data) => {
                    if (data.length > 0) {
                        this.lstWarehouse = data;
                    }
                });
        },
        getLocation() {
            axios.post(
                    process.env.VUE_APP_API_URL + "/category/listByTypeOrderByCodeAsc?type=OFFICE_LOCATION"
                )
                .then(
                    (data) => {
                        if (data.length > 0) {
                            let itemFields = this.fields.filter(function (e) {
                                return e.name == "locationId";
                            });
                            if (itemFields != undefined && itemFields.length > 0) {
                                itemFields[0].items = data;
                            }
                        }
                    }
                );
        },
        getDepartment() {
            axios.post(process.env.VUE_APP_API_URL + "/department/search?pageSize=-1&page=-1", {})
            .then(
                (data) => {
                    if (data.items) {
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "departmentId";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data.items;
                        }
                    }
                }
            );
        },
        onChangeWh(warehouseId) {
            this.hiddenFields = Object.assign(this.hiddenFields, {warehouseId: warehouseId});
            this.$store.commit("fixedAssets/setWarehouseId", warehouseId);
        },
    },

    destroyed() {},
};
</script>
